export class TeamBalancingCandidateEntity {
  public teamId!: string;
  public teamName!: string;
  public overCapacityCount!: number;
  public overdueCount!: number;
}
